import moment from 'jalali-moment';

import { _post } from '../../utils/network';
import { contentLevelLabel, contentLevelOptions } from '../../utils/content-level';

export const toShamsiDate = date => date ? moment(date.substring(0, 10), 'YYYY-MM-DD').locale('fa').format('jYYYY/jMM/jDD') : '';

export const shamsiToGregorian = date => moment(date, 'jYYYY/jMM/jDD').locale('en').format('YYYY-MM-DD');

export const slugify = value => value.trim().toLowerCase().replace(/[/?#]+/g, '').replace(/\s+/g, '-');

export const isValidSlug = value => value.length >= 3 && !/[\s/?#]/.test(value);

export { contentLevelLabel, contentLevelOptions };

/** Blog categories as FormField select items. */
export const fetchBlogCategoryOptions = async () => {
	const response = await _post('/blog_categories/admin/getBlogCategories', {});
	if(response.code !== 200)
		return { options: [], response };
	return { options: response.data.blog_categories.map(category => ({ key: category.title, value: category.id })), response };
};
